import React from 'react';
import MUIDataTable from "mui-datatables";
import { withStyles, createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Media from 'react-media';
import $ from "jquery";

import TextLabels from './TextLabels';

const MaterialTableDemo = (props) => {
  
  const columns = props.state.columns;
  const data = props.state.itensTable;

  const options = {
    serverSide: props.state.serverSide==null?false:props.state.serverSide,
    count: props.state.count,
    sortOrder: props.state.sortOrder==null?true:props.state.sortOrder,
    filter: props.state.filter==null?true:props.state.filter,
    search: props.state.search==null?true:props.state.search,
    sort: props.state.sort==null?true:props.state.sort,
    download: props.state.download==null?true:props.state.download,
    sortFilterList: props.state.sortFilterList==null?true:props.state.sortFilterList,
    viewColumns: props.state.viewColumns==null?true:props.state.viewColumns,
    print: props.state.print==null?false:props.state.print,
    filterType: 'textField',
    selectableRows: props.state.selectableRows==null?"none":props.state.selectableRows,
    onRowClick: props.state.onRowClick,
    onCellClick: props.state.onCellClick,
    customSort: props.state.customSort,
    customToolbar: props.state.customToolbar,
    customToolbarSelect: props.state.customToolbarSelect,
    customFooter: props.state.customFooter,
    onRowsSelect: props.state.onRowsSelect,
    elevation: props.state.elevation==null?1:props.state.elevation,
    onTableChange: props.state.onTableChange,
    onChangePage: props.state.onChangePage,
    onRowsPerPageChange: props.state.onChangeRowsPerPage,
    rowsPerPage: props.state.rowsPerPage==null?15:props.state.rowsPerPage,
    rowsPerPageOptions: props.state.rowsPerPageOptions==null?[15]:props.state.rowsPerPageOptions,
    responsive: props.state.responsive==null?"scrollFullHeight":props.state.responsive,
    pagination: props.state.pagination==null?true:props.state.pagination,
    rowHover: props.state.rowHover==null?true:props.state.rowHover,
    textLabels: TextLabels,
    customRowRender: props.state.customRowRender,
    setRowProps: props.state.setRowProps,
    downloadOptions: {
      filename: (props.state.nameCSV==null?props.state.title+'.csv':props.state.nameCSV+'.csv'), 
      separator: ';'
    },
    fixedHeaderOptions: {xAxis: true, yAxis: true},
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data); 
    },
    setTableProps: () => {
      return {
        size: props.state.size==null?"small":props.state.size,
      };
    },
  };

  return (
    <div>
      <div className={"wrapper1"} style={{
        "width": "100%",
        "overflowX": "scroll",
        "overflowY": "hidden",
        "display": "none",
      }}>
        <div className={"scrollInside"} style={{
          "height": "20px"
        }}></div>
      </div>
      <MUIDataTable
        title={props.state.title}
        data={data}
        columns={columns}
        options={options}
        className={" Table wrapper2 "}            
      />
    </div>
  );
}

export default class BodyCellExample extends React.Component {

  componentDidMount() {
    $(document).ready(() => {

      //colocando primeira letra maiscula
      $($(".Table > div > div > div > h6")).css('text-transform','none');
      $($(".Table > div > div > div > h6")).text(this.upfirst($($(".Table > div > div > div > h6")).text()));

      //verifica se tem filtro para position rodape
      if (
        $("#filtroAdm") &&
        $($("#filtroAdm")) &&
        $($("#filtroAdm"))[0] &&
        $($("#filtroAdm"))[0].offsetHeight >= 65
      ) {
        //console.log("tem filtro");
        $($($(".Table").children().get(2))[0]).css("max-heigth","calc(100vh - 136px)");
      } else {
        //console.log("n tem filtro");
        $($($(".Table").children().get(2))[0]).css("max-heigth","calc(100vh - 136px)")
      }
      
    });
  }


  upfirst(str) {
    return str.charAt(0).toUpperCase() + str.toLowerCase().substring(1);
  };

  getMuiTheme = () => createTheme({
    overrides: {
      MUIDataTableBodyCell: {
        root: {
          fontSize: (this.props.state&&this.props.state.fontSize)?this.props.state.fontSize:'11pt',          
          padding: (this.props.state&&this.props.state.padding)?this.props.state.padding:'5px !important',
          textAlign: 'center'
        }
      }, 
    }
  });
 
  render() {
    const {...props} = this.props;
 
    return (
        <MaterialTableDemo {...props}/>
    );
 
  };
};